import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    labelProps: {
        css: css`
            font-weight: bold;
            font-size: 16px;
            line-height: 17px;
            &&& {
                margin-bottom: 8px;
            }
        `,
    },
    css: css`
        & ${RadioStyle} + ${RadioStyle} {
            margin-top: 2px;
        }
    `,
};

cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-top: 8px;
        `,
    },
    headerText: {
        weight: "bold",
        lineHeight: "17px",
        css: css`
            margin-bottom: 8px;
        `,
    },
    changeLink: {
        css: css`
            margin-left: 15px;
        `,
    },
    warehouseAddress: {
        wrapper: {
            css: css`
                margin-top: 8px;
            `,
        },
        nameText: {
            as: "p",
            size: 14,
        },
        address: {
            customerNameText: { as: "p", size: 14 },
            attentionText: { as: "p", size: 14 },
            companyNameText: { as: "p", size: 14 },
            address1Text: { as: "p", size: 14 },
            address2Text: { as: "p", size: 14 },
            address3Text: { as: "p", size: 14 },
            address4Text: { as: "p", size: 14 },
            cityStatePostalCodeText: { as: "p", size: 14 },
            countryText: { as: "p", size: 14 },
            phoneText: { as: "p", size: 14 },
            emailText: { as: "p", size: 14 },
            faxText: { as: "p", size: 14 },
        },
    },
};
